import React from "react";

function Counter({ quantity, onQuantityChange, max }) {
  const handleIncrement = () => {
    if (max !== undefined && quantity < max) {
      onQuantityChange(quantity + 1);
    } else if (max === undefined) {
      onQuantityChange(quantity + 1);
    }
  };

  const handleDecrement = () => {
    if (max) {
      if (quantity > 0) {
        onQuantityChange(quantity - 1);
      }
    } else if (quantity > 1) {
      onQuantityChange(quantity - 1);
    }
  };

  return (
    <div className={`flex items-center mx-auto gap-3  w-max `}>
      <button onClick={handleDecrement} className="text-[1.2rem]">
        -
      </button>
      <span>{quantity}</span>
      <button onClick={handleIncrement} className="text-[1.2rem]">
        +
      </button>
    </div>
  );
}

export default Counter;
